export var SESSION_TRAFFIC_SOURCE_KEY = "traffic-source";
export var SESSION_WALLET_DETECTED_KEY = "wallet-detected";
export var SESSION_CURRENT_URL_KEY = "analytics-current-url";
export var SESSION_USER_ID_KEY = "user-id";
export var LOCAL_ANONYMOUS_ID_KEY = "anonymous-id";
//# sourceMappingURL=base.js.map